









































































































































































































































































































































































































































































































































































import Vue, { VNode } from 'vue'
import DescriptionElement from '@/components/DescriptionElement.vue'
import { buyMoreCart } from '@/api/cart'
import { IBuyMoreCartRequest, ICartItem, IRecommendedItem, IUpdateCartRequest, IUpdatedCartItem, IUpdatedBuyMoreCartItem, IAddToCartAction, IBuyMoreCartItem } from '@/interfaces/cart'
import postAppMessage, { MessageHandlers } from '@/utils/poster'
import { checkNoMeshById } from '@/utils'
import VueRouter from 'vue-router'
import { CartType } from '@/store/types'
import { mapState, mapGetters } from 'vuex'
import QuantitySelector from '@/components/QuantitySelector.vue'
import { MetaInfo } from 'vue-meta/types/vue-meta'
import moment from 'moment'

export default Vue.extend({
  name: 'Cart',
  components: { QuantitySelector, DescriptionElement },
  data () {
    return {
      updatedList: [] as IUpdatedCartItem[],
      checkedAll: false,
      indeterminate: false,
      checkedCartItemsCount: 0,
      isLoading: false,
      isLoadedCart: false,
      isShowToast: false,
      debounceTimeId: 0,
      isShowAdditionalList: false,
      updatedAdditionalList: [] as IUpdatedBuyMoreCartItem[],
      forceUpdateCart: false,
      isAddRecommendedItemApiPending: false,
      coinText: '',
      nuCoinText: '消費滿200，可累積nu幣，折抵下次消費',
      promoteMsg: ''
    }
  },
  metaInfo (): MetaInfo {
    return {
      title: '購物車',
      titleTemplate: '%s | nuPhoto 拍立洗'
    }
  },
  computed: {
    ...mapState(['showNuCoin']),
    ...mapGetters({
      noDeliverFeePrice: 'noDeliverFeePrice',
      recommendationList: 'recList',
      amount: 'cartAmount'
    }),
    // mapGetters helper work in runtime, for type check need to declare in static typeing environment.
    cartList (): ICartItem[] {
      return this.$store.getters.cartList
    },
    additionalPurchasesList (): IUpdatedBuyMoreCartItem[] {
      return (this.$store.getters.buyMoreListCart as IBuyMoreCartItem[]).map((bm) => { return { ...bm, setAmount: 0 } })
    }
  },
  watch: {
    cartList: function () {
      this.setCheckedAllButton()
    },
    '$store.getters.orderInfo': function (newValue) {
      if (newValue !== null && newValue.success === 0) {
        this.checkOrderInfoAndShowErrorModal()
      }
    }
  },
  async created () {
    window.handleGetCartList = this.onCartRefreshClicked
    this.$on('loadData', () => {
      this.onCartRefreshClicked()
    })
    this.isLoadedCart = false
    this.forceUpdateCart = false
    // Check user is not load into this page with url enter. if yes, we get cart list when $store.getters.isInitialized changed.
    // And we should load cartlist in webview mode.
    if (this.$store.getters.from !== null || this.$store.getters.isWebViewMode) {
      await this.handleGetCartList()
    } else if (this.$store.getters.from === null) {
      // Wait until token is initialized
      while (!this.$store.getters.isInitialized) {
        await new Promise((resolve) => {
          setTimeout(resolve, 100)
        })
      }
      await this.handleGetCartList()
    }
    if (this.$store.getters.webAppCaps) {
      if (typeof this.$store.getters.webAppCaps.promote_msg !== 'undefined') {
        this.promoteMsg = this.$store.getters.webAppCaps.promote_msg
      }
    }
    // The code under this line will excute without waiting this.handleGetCartList() response. Make sure to having await if you need to use the response data.
  },
  methods: {
    onCartRefreshClicked () {
      this.isShowAdditionalList = false
      this.handleGetCartList()
    },
    checkOrderInfoAndShowErrorModal () {
      // If is back from route in checkout, since success is 0
      if (this.$store.getters.orderInfo && this.$store.getters.orderInfo.success === 0) {
        postAppMessage(MessageHandlers.UPDATE_ROUTE, this.$route.name)
        const message = this.$store.getters.orderInfo.msg as string
        const h = this.$createElement
        const messageVNode = [] as VNode[]
        message.split('\\n').forEach(text => {
          console.log(text)
          if (text.length > 0) { messageVNode.push(h('p', text)) }
        })

        this.$bvModal.msgBoxOk(messageVNode, {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
        this.isShowAdditionalList = false
        this.isLoadedCart = true
        this.isLoading = false
      }
    },
    onCartItemImageClicked (cartItem: ICartItem) {
      if (cartItem.photo_product === 0) {
        this.onRecommendationClicked(cartItem.product_id)
      } else if (cartItem.photo_product === 1) {
        this.$router.push({ name: 'OrderDetails', params: { orderId: cartItem.id } })
      }
    },
    onRecommendationClicked (index: number) {
      const productId = index.toString()
      if (this.$store.getters.isWebViewMode) {
        postAppMessage(MessageHandlers.NAVIGATE_TO_PRODUCT, productId)
      } else {
        this.$router.push({ name: 'Product', params: { productId } })
      }
    },
    onDecreaseAmountClicked (index: number) {
      if (this.cartList[index].qty > 0) {
        this.addToUpdateListInBackground(index)
      }
    },
    onIncreaseAmountClicked (index: number) {
      if (this.cartList[index].qty < this.cartList[index].stock_qty) {
        this.addToUpdateListInBackground(index)
      }
    },
    onDecreaseAdditionQuantityClicked (index: number) {
      if (this.additionalPurchasesList[index].setAmount >= 0) {
        this.addAdditionToUpdateListInBackground(index)
      }
    },
    onIncreaseAdditionQuantityClicked (index: number) {
      if (this.additionalPurchasesList[index].setAmount <= this.additionalPurchasesList[index].qty) {
        this.addAdditionToUpdateListInBackground(index)
      }
    },
    async onNextClicked () {
      this.isLoading = true
      // Check checked items update list
      if (this.debounceTimeId !== 0) {
        clearTimeout(this.debounceTimeId)
        try {
          await this.handleUpdateCart()
        } catch (error) {
          console.log(error)
          return
        }
      }
      this.isShowAdditionalList = true
      this.isLoading = false
    },
    // Cart item input changed
    onInputQuantityChanged (index: number) {
      if (this.cartList[index].qty <= 0) this.cartList[index].qty = 1
      if (this.cartList[index].qty > this.cartList[index].stock_qty) {
        this.cartList[index].qty = this.cartList[index].stock_qty
        this.$bvModal.msgBoxOk('數量超過商品剩餘數量', {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      }
      this.addToUpdateListInBackground(index)
    },
    // Additional Purchase item input changed
    onInputAdditionQuantityChanged (index: number) {
      if (this.additionalPurchasesList[index].setAmount <= 0) {
        this.additionalPurchasesList[index].setAmount = 0
      }
      if (this.additionalPurchasesList[index].setAmount > this.additionalPurchasesList[index].qty) {
        this.additionalPurchasesList[index].setAmount = this.additionalPurchasesList[index].qty
        this.$bvModal.msgBoxOk('數量超過商品剩餘數量', {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      }
      this.addAdditionToUpdateListInBackground(index)
    },
    // In order to avoid keeping invoke update cart API when user has not finish updated, we keep the update infomation in the list, once handleUpdateCart invoked, the items in the list will also be updated.
    addToUpdateListInBackground (index: number) {
      const findItemIndex = this.updatedList.findIndex(item => item.id === this.cartList[index].id)
      const replaceItem = { ...this.cartList[index], deleted: 0 }
      if (findItemIndex === -1) {
        this.updatedList.push(replaceItem)
      } else {
        this.updatedList[findItemIndex] = replaceItem
      }
      this.sendUpdateItemAfterDebounceTime()
    },
    addAdditionToUpdateListInBackground (index: number) {
      const findItemIndex = this.updatedAdditionalList.findIndex(item => item.variant_id === this.additionalPurchasesList[index].variant_id)
      const replaceItem = this.additionalPurchasesList[index]
      if (findItemIndex === -1) {
        this.updatedAdditionalList.push(replaceItem)
      } else {
        this.updatedAdditionalList[findItemIndex] = replaceItem
      }
      this.sendUpdateItemAfterDebounceTime()
    },
    sendUpdateItemAfterDebounceTime () {
      if (this.debounceTimeId) {
        clearTimeout(this.debounceTimeId)
        this.debounceTimeId = 0
      }
      this.debounceTimeId = setTimeout(() => {
        if (this.updatedList.length > 0) {
          this.handleUpdateCart()
        }
        if (this.updatedAdditionalList.length > 0) {
          this.handleBuyMoreCart()
        }
        this.debounceTimeId = 0
      }, 500)
    },
    setCheckedAllButton () {
      this.indeterminate = false
      let checkedCount = 0
      if (this.cartList && this.cartList.length > 0) {
        checkedCount = this.cartList.reduce((acc, item) => { return acc + item.checked }, 0)
        this.checkedAll = checkedCount === this.cartList.length
      } else {
        this.checkedAll = false
      }
      this.checkedCartItemsCount = checkedCount

      if (this.checkedAll) {
        this.indeterminate = false
      } else {
        this.indeterminate = checkedCount !== 0
      }
    },
    onCheckedAllToggled () {
      // the value will be updated at next tick
      this.updatedList = []
      this.$nextTick(() => {
        // new value here
        for (const item of this.cartList) {
          item.checked = ~~this.checkedAll
          // No need to push to the update list now, since sendUpdateItemAfterDebounceTime will do it.
          // this.updatedList.push({ ...item, deleted: 0 })
        }
      })
    },
    onItemCheckedChanged (cartIndex: number) {
      this.addToUpdateListInBackground(cartIndex)
      this.setCheckedAllButton()
    },
    async addRecommendedItemToCart (item: IRecommendedItem) {
      if (this.isAddRecommendedItemApiPending) {
        return
      }
      this.isAddRecommendedItemApiPending = true
      if (item.direct_add === 1) {
        try {
          const token = this.$store.getters.isWebViewMode ? this.$route.query.token : this.$store.getters.token
          const requestBody = {
            token,
            variant_id: item.variant_id,
            qty: 1,
            return_cart: 1,
            title: item.title
          } as IAddToCartAction

          const response = await this.$store.dispatch('ADD_TO_CART', requestBody)
          this.isAddRecommendedItemApiPending = false
          if (response.flag === 0) {
            this.notifyAppToUpdateCartBadge(response.data.count)
            this.popToast()
          } else if (response.flag === 2) {
            this.$bvModal.msgBoxOk('您已在其他地方登入，請重新登入。', {
              centered: true,
              footerClass: 'msgbox-ok-footer',
              okTitle: '確定'
            }).then(() => {
              if (this.$route.query.webview !== '1') {
                this.$router.push({ name: 'Login', query: { redirect: this.$route.path } })
              }
            })
          }
        } catch (error) {
          this.isAddRecommendedItemApiPending = false
          console.error(error)
          this.$bvModal.msgBoxOk(`載入資料失敗，${error.message}`, {
            centered: true,
            footerClass: 'msgbox-ok-footer',
            okTitle: '確定'
          })
        }
      }
    },
    popToast () {
      this.isShowToast = true
      setTimeout(() => { this.isShowToast = false }, 2000)
    },
    async handleGetCartList () {
      this.isLoading = true
      try {
        // type = 0, get cart list
        const response = await this.$store.dispatch('GET_CART_LIST', CartType.cart)
        console.log(`Cart: ${moment().format('YYYY/MM/DD HH:mm:ss.SSS')}`)
        if (response.flag === 2) {
          this.$bvModal.msgBoxOk('您已在其他地方登入，請重新登入。', {
            centered: true,
            footerClass: 'msgbox-ok-footer',
            okTitle: '確定'
          }).then(() => {
            if (this.$route.query.webview !== '1') {
              this.$router.push({ name: 'Login', query: { redirect: this.$route.path } })
            }
          })
        } else if (response.flag === 0) {
          this.coinText = response.data.coin_text
          if (response.data.nucoin_text.length > 0) {
            this.nuCoinText = response.data.nucoin_text
          }
        }
      } catch (error) {
        this.$bvModal.msgBoxOk('獲取購物車時發生錯誤，請排除網路問題後再重試，若還有此狀況發生，請聯絡我們的客服協助您處理。', {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      } finally {
        this.setCheckedAllButton()
        this.isLoadedCart = true
        this.isLoading = false
      }
    },
    /**
     * Update cart list API method, if given parameters are not null, this method will check whether the updated list is empty or not, if it is empty it will update the value upon the parameters, otherwise it will force update the whole update list.
     * @param cartIndex: the cart item index will be modified, if you want to update all cart items, let this field empty.
     * @param deleted: Should this item be deleted? Does not work when updating all cart items.
     **/
    async handleUpdateCart (cartIndex: number | void, deleted: boolean | void) {
      this.isLoading = true
      const updateItems = [] as Array<string>
      let updateStr = ''
      if (cartIndex !== undefined && this.updatedList.length === 0) {
        const item = { ...this.cartList[cartIndex], deleted: ~~deleted }
        updateStr = `${item.id}:${item.qty}:${item.checked}:${item.deleted}`
      } else {
        if (cartIndex !== undefined) {
          // We have item need to be updated in queue, so add current item to queue.
          const item = { ...this.cartList[cartIndex], deleted: ~~deleted }
          this.updatedList.push(item)
        }

        // Then we create the string by the queue.
        for (const item of this.updatedList) {
          updateItems.push(`${item.id}:${item.qty}:${item.checked}:${item.deleted}`)
        }
        updateStr = updateItems.join(',')
      }

      const token = this.$store.getters.isWebViewMode ? this.$route.query.token : this.$store.getters.token
      const requestBody = {
        token,
        update_list: updateStr,
        return_cart: ~~deleted
      } as IUpdateCartRequest

      // Reset update list
      this.updatedList = []

      try {
        const response = await this.$store.dispatch('UPDATE_CART', { deleted, data: requestBody })
        this.isLoading = false
        if (response.flag === 0 || response.flag === 1) {
          this.notifyAppToUpdateCartBadge(response.data.count)
          this.checkedCartItemsCount = response.data.count
          return Promise.resolve()
        } else if (response.flag === 2) {
          this.$bvModal.msgBoxOk('您已在其他地方登入，請重新登入。', {
            centered: true,
            footerClass: 'msgbox-ok-footer',
            okTitle: '確定'
          }).then(() => {
            if (this.$route.query.webview !== '1') {
              this.$router.push({ name: 'Login', query: { redirect: this.$route.path } })
            }
          })
          return Promise.reject(new Error('您已在其他地方登入，請重新登入。'))
        }
      } catch (error) {
        console.error(error)
        this.$store.commit('logger/PUSH_LOG', error)
        this.handleGetCartList()
        this.$bvModal.msgBoxOk(`更新購物車時發生錯誤，${error}`, {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
        return Promise.reject(error)
      }
    },
    async handleBuyMoreCart (index: number | void) {
      this.isLoading = true
      const updateItems = [] as Array<string>
      let updateStr = ''
      for (const item of this.updatedAdditionalList) {
        updateItems.push(`${item.variant_id}:${item.setAmount}`)
      }
      if (index !== undefined) {
        const item = this.additionalPurchasesList[index]
        updateItems.push(`${item.variant_id}:${item.setAmount}`)
      }
      updateStr = updateItems.join(',')

      const token = this.$store.getters.isWebViewMode ? this.$route.query.token : this.$store.getters.token
      const requestBody = {
        token,
        buymore_list: updateStr
      } as IBuyMoreCartRequest

      // Reset update list
      this.updatedAdditionalList = []

      try {
        const { data } = await buyMoreCart(requestBody)
        const payload = data.data
        if (data.flag === 0) {
          for (const buyMoreItem of payload.buymore_result) {
            const targetChangeItem = this.additionalPurchasesList.find(p => p.variant_id === buyMoreItem.variant_id)
            if (targetChangeItem) { targetChangeItem.setAmount = buyMoreItem.qty }
          }
          this.$store.commit('SET_CART_AMOUNT', payload.amount)
          this.$store.commit('SET_CART_COUNT', payload.count)
          this.notifyAppToUpdateCartBadge(payload.count)
        }
        this.isLoading = false
        return Promise.resolve()
      } catch (error) {
        console.error(error)
        this.handleGetCartList()
        this.$store.commit('logger/PUSH_LOG', error)
        this.$bvModal.msgBoxOk(`加購商品時發生錯誤，${error}`, {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
        return Promise.reject(error)
      }
    },
    async handleGoToCheckout () {
      this.isLoading = true
      if (this.debounceTimeId !== 0) {
        clearTimeout(this.debounceTimeId)
        try {
          await this.handleBuyMoreCart()
        } catch (error) {
          console.log(error)
          return
        }
      }
      this.isLoading = true
      this.$router.push({ name: 'Checkout', query: this.$route.query }).catch(error => {
        if (!VueRouter.isNavigationFailure(error, VueRouter.NavigationFailureType.redirected)) {
          this.$bvModal.msgBoxConfirm(`${error.message}是否要再次嘗試？`, {
            centered: true,
            noCloseOnBackdrop: true,
            noCloseOnEsc: true,
            footerClass: 'msgbox-confirm-footer',
            cancelTitle: '否',
            okTitle: '是'
          }).then((result) => {
            if (result) this.handleGoToCheckout()
          })
        }
      })
    },
    notifyAppToUpdateCartBadge (count: number) {
      postAppMessage(MessageHandlers.UPDATE_CART_BADGE, count)
    },
    noMeshById (tmpItem: ICartItem): boolean {
      return checkNoMeshById(tmpItem.product_id)
    }
  }
})
